module.exports = __webpack_public_path__ + "static/media/apple-store.e7ddcc40.png";